import { cloneDeep } from "lodash-es";
import { universalTemplate } from "../templates/Universal";
import { codeSchemaFields } from "../templates/utils/code";
import { schemaFind } from "./schemaUtil";
export function getDBResponseBodySchema(api, entity) {
  var _entity$fields;
  const apiTemplate = universalTemplate.apiTemplates.find(item => item.name === api);
  const defaultBodySchema = {
    title: '返回包体',
    type: 'object',
    ...codeSchemaFields
  };
  if (!apiTemplate) return defaultBodySchema;
  const {
    response
  } = apiTemplate;
  const {
    body
  } = response;
  if (!body) return defaultBodySchema;
  const bodySchema = cloneDeep(body);
  const targetSchema = schemaFind(bodySchema, schema => schema.injectEntity);
  const hasEntity = entity === null || entity === void 0 || (_entity$fields = entity.fields) === null || _entity$fields === void 0 ? void 0 : _entity$fields.length;
  if (targetSchema && hasEntity) {
    if (targetSchema.type === 'array') {
      targetSchema.items = entity;
    } else {
      Object.assign(targetSchema, entity);
    }
  }
  return bodySchema;
}
;
//# sourceMappingURL=getDBResponseBodySchema.js.map
